export default "__VITE_ASSET__CXjY7vkZ__"